import {
  PvGenerationData,
  PvGenerationSummary,
  CreatePvAnlageRequest,
  UpdatePvAnlageRequest,
  PvConfigurationSuggestions,
  ValidationResult
} from '../../types/pv';
import { TechnischeRessource } from '../../types/network';
import { networkApi } from '../../infrastructure/api/NetworkApiClient';

export class PvAnlageApi {
  /**
   * Get all PV systems for a specific Hausanschluss
   */
  async getPvSystems(hausanschlussId: string): Promise<TechnischeRessource[]> {
    return networkApi.httpGet<TechnischeRessource[]>(`/pvanlage/${hausanschlussId}/systems`);
  }

  /**
   * Get a specific PV system by ID
   */
  async getPvSystem(hausanschlussId: string, pvId: string): Promise<TechnischeRessource> {
    return networkApi.httpGet<TechnischeRessource>(`/pvanlage/${hausanschlussId}/systems/${pvId}`);
  }

  /**
   * Create a new PV system
   */
  async createPvSystem(
    hausanschlussId: string,
    request: CreatePvAnlageRequest
  ): Promise<TechnischeRessource> {
    return networkApi.httpPost<TechnischeRessource>(`/pvanlage/${hausanschlussId}/systems`, request);
  }

  /**
   * Update an existing PV system
   */
  async updatePvSystem(
    hausanschlussId: string,
    pvId: string,
    request: UpdatePvAnlageRequest
  ): Promise<TechnischeRessource> {
    return networkApi.httpPut<TechnischeRessource>(`/pvanlage/${hausanschlussId}/systems/${pvId}`, request);
  }

  /**
   * Delete a PV system
   */
  async deletePvSystem(hausanschlussId: string, pvId: string): Promise<void> {
    return networkApi.httpDelete(`/pvanlage/${hausanschlussId}/systems/${pvId}`);
  }

  /**
   * Get current power generation for a specific PV system
   */
  async getCurrentGeneration(
    hausanschlussId: string,
    pvId: string
  ): Promise<PvGenerationData> {
    return networkApi.httpGet<PvGenerationData>(`/pvanlage/${hausanschlussId}/systems/${pvId}/generation`);
  }

  /**
   * Get current power generation for all PV systems in a Hausanschluss
   */
  async getAllCurrentGeneration(
    hausanschlussId: string
  ): Promise<Record<string, PvGenerationData>> {
    return networkApi.httpGet<Record<string, PvGenerationData>>(`/pvanlage/${hausanschlussId}/generation`);
  }

  /**
   * Get summary of all PV generation in the system
   */
  async getGenerationSummary(): Promise<PvGenerationSummary> {
    return networkApi.httpGet<PvGenerationSummary>('/pvanlage/generation/summary');
  }

  /**
   * Get optimal configuration suggestions for a PV system based on location
   */
  async getOptimalConfiguration(
    latitude: number,
    longitude: number
  ): Promise<PvConfigurationSuggestions> {
    return networkApi.httpGet<PvConfigurationSuggestions>(
      `/pvanlage/configuration/suggestions?latitude=${latitude}&longitude=${longitude}`
    );
  }

  /**
   * Validate PV system configuration
   */
  async validateConfiguration(request: CreatePvAnlageRequest): Promise<ValidationResult> {
    return networkApi.httpPost<ValidationResult>('/pvanlage/configuration/validate', request);
  }
}

// Export singleton instance
export const pvAnlageApi = new PvAnlageApi();

